import React, { useState, useEffect } from "react";

const Counter = ({
  targetValue,
  duration = 500,
}: {
  targetValue: string;
  duration?: number;
}) => {
  const [count, setCount] = useState(0);

  useEffect(() => {
    let start = 0;
    const end = parseInt(targetValue);
    if (start === end) return;

    // Calcular cuánto tiempo tarda cada incremento
    const totalSteps = 60; // 60 FPS
    const increment = end / totalSteps;
    const stepTime = duration / totalSteps;

    const timer = setInterval(() => {
      start += increment;
      if (start >= end) {
        setCount(end);
        clearInterval(timer);
      } else {
        setCount(Math.ceil(start));
      }
    }, stepTime);

    return () => clearInterval(timer);
  }, [targetValue, duration]);

  return <label className="value">{count}</label>;
};

export default Counter;
